import type { ReactElement } from 'react';
import { Bell } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface NewMcpServersBannerProps {
  newCount: number;
  newWindowDays: number;
  onReviewNew: () => void;
}

/**
 * KIR-4482 A4: banner at the top of the MCP Servers tab with the count of New
 * servers and a "Review new" action that switches the table to the New chip.
 */
export function NewMcpServersBanner({
  newCount,
  newWindowDays,
  onReviewNew,
}: NewMcpServersBannerProps): ReactElement {
  const plural = newCount !== 1;
  return (
    <div
      role="status"
      className="flex items-center gap-3 rounded-md border border-amber-200 bg-amber-50 px-4 py-3 dark:border-amber-900 dark:bg-amber-950/40"
    >
      <Bell className="size-5 shrink-0 text-amber-600" aria-hidden />
      <div className="flex-1 text-sm">
        <p className="font-semibold text-amber-900 dark:text-amber-100">
          {newCount} new MCP server{plural ? 's' : ''} {plural ? 'were' : 'was'}{' '}
          identified in the last {newWindowDays} days.
        </p>
        <p className="text-amber-800 dark:text-amber-200">
          Review each new server and choose to allow or block it. Blocking is
          enforced using hooks.
        </p>
      </div>
      <Button type="button" size="sm" onClick={onReviewNew}>
        Review new
      </Button>
    </div>
  );
}
